require('./hiringProductInformationAdvantages.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
// @components
const HiringProductInformationRiskLevel = require('./hiringProductInformationRiskLevel');

class HiringProductInformationAdvantages extends React.Component {

    buildAdvantage(immAdvantages) {
        
        const advantages = immAdvantages.map((advantage) => {
            const key = `${advantage.get('id')}`;
            return (
                <div className="hiring-product-information-advantages col-xs-6" key={key}>
                    <div className="hiring-product-information-advantages__icon">
                        <div className={advantage.get('icon')}></div>
                    </div>
                    <div className="hiring-product-information-advantages__title">
                        {advantage.get('text')}
                    </div>
                    <span className="hiring-product-information-advantages__separator"></span>
                    <HTMLSafeInjector
                        customClass="hiring-product-information-advantages__paragraph"
                        message={advantage.get('description')}
                    />
                </div>
            )
        });

        return (
            <div className="row">
                {advantages}
            </div>
        );
    }

    render() {
        const { immAdvantages, immRiskLevel, immRiskLiquidityAlert } = this.props;
        let riskLevelContent;

        const productAdvantagesSectionClass = classnames({ 'col-xs-12': !immRiskLevel.size}, {
            'hiring-product-information-advantages__section col-xs-8' : immRiskLevel.size > 0
        });

        if (immRiskLevel.size > 0) {
            riskLevelContent = (
                <div className="hiring-product-information-risks col-xs-4">
                    <HiringProductInformationRiskLevel
                        immRiskLevel={immRiskLevel}
                        immRiskLiquidityAlert={immRiskLiquidityAlert}
                    />
                </div>
            );
        }

        const middle = Math.round(immAdvantages.size / 2);
        const firstSection = immAdvantages.slice(0, middle);
        const secondSection = immAdvantages.slice(middle, immAdvantages.size);
        
        const contentAdvantages = (
            <React.Fragment>
                {this.buildAdvantage(firstSection)}
                {this.buildAdvantage(secondSection)}
            </React.Fragment>
        )

        return (
            <React.Fragment>
                <div className={productAdvantagesSectionClass}>
                    {contentAdvantages}
                </div>
                {riskLevelContent}
            </React.Fragment>
        );
    }
}

HiringProductInformationAdvantages.propTypes = {
    immAdvantages: PropTypes.object.isRequired,
    immRiskLevel: PropTypes.object.isRequired,
    immRiskLiquidityAlert: PropTypes.object.isRequired,
};

module.exports = HiringProductInformationAdvantages;